import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.2_@babel+core@7.26.10_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.2_@babel+core@7.26.10_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.2_@babel+core@7.26.10_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/landing/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExploreServicesButton"] */ "/vercel/path0/src/app/components/landing/ExploreServicesButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroVisuals"] */ "/vercel/path0/src/app/components/landing/HeroVisuals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundGlow"] */ "/vercel/path0/src/app/components/landing/our-services/BackgroundGlow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/app/components/landing/our-services/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServicesSection"] */ "/vercel/path0/src/app/components/landing/our-services/ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialProof"] */ "/vercel/path0/src/app/components/landing/social-proof.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/landing/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/landing/what-we-do/components/SpotlightHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/landing/what-we-do/components/timeline/WhatWeDoIMG.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyChooseUs"] */ "/vercel/path0/src/app/components/landing/why-choose-us.tsx");
